import { HttpClient } from 'shared/libs/http';
import {
  CandidateEditProfileResponse,
  CandidateEditProfileDto,
  CandidatesGetActiveCvList,
  LocalitySearchResponse,
  LocalitySearchDto,
  GetPositionDto,
  GetPostionResponse,
} from './types';
import { CandidateEditProfileEmptyResponse } from './types/candidate-edit-profile-empty-response';

export class CandidateApiService {
  public static async candidatesEditProfile<TDto extends CandidateEditProfileDto | null>(
    dto: TDto
  ) {
    return await HttpClient.post<
      TDto extends null ? CandidateEditProfileEmptyResponse : CandidateEditProfileResponse
    >('/candidates/editProfile', dto);
  }

  public static async candidatesGetActiveCvList() {
    return await HttpClient.get<CandidatesGetActiveCvList>('/candidates/getActiveCvList');
  }

  public static async localitySearch(dto: LocalitySearchDto) {
    return await HttpClient.post<LocalitySearchResponse>('/locality/search', dto);
  }

  public static async getPositions(dto: GetPositionDto) {
    return await HttpClient.post<GetPostionResponse>('/candidates/getPositions', dto);
  }
}
